(function () {
  function buildSortDropdown(selectEl) {
    if (!selectEl || selectEl.dataset.apexSortBuilt) return;
    selectEl.dataset.apexSortBuilt = '1';

    var form = selectEl.closest('form');
    if (!form) return;

    var selectedOption = selectEl.options[selectEl.selectedIndex];
    var selectedText = selectedOption ? selectedOption.text : '';

    // Build wrapper
    var wrapper = document.createElement('div');
    wrapper.className = 'apex-sort';

    // Trigger button
    var trigger = document.createElement('div');
    trigger.className = 'apex-sort__trigger';
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.innerHTML =
      '<span class="apex-sort__value">' + selectedText + '</span>' +
      '<svg class="apex-sort__caret" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

    // Options list
    var list = document.createElement('div');
    list.className = 'apex-sort__list';
    list.setAttribute('role', 'listbox');

    for (var i = 0; i < selectEl.options.length; i++) {
      var opt = selectEl.options[i];
      var item = document.createElement('div');
      item.className = 'apex-sort__option' + (opt.selected ? ' apex-sort__option--active' : '');
      item.setAttribute('role', 'option');
      item.setAttribute('data-value', opt.value);
      item.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
      item.textContent = opt.text;
      list.appendChild(item);
    }

    wrapper.appendChild(trigger);
    wrapper.appendChild(list);

    // Hide native select + its caret wrapper, insert custom before it
    selectEl.style.display = 'none';
    var selectWrap = selectEl.closest('.select');
    if (selectWrap) {
      selectWrap.style.display = 'none';
      selectWrap.parentNode.insertBefore(wrapper, selectWrap);
    } else {
      selectEl.parentNode.insertBefore(wrapper, selectEl);
    }

    // Remove border/padding from the original field wrapper since apex-sort handles that
    var field = selectEl.closest('.facet-filters__field');
    if (field) {
      field.style.border = 'none';
      field.style.padding = '0';
      field.style.background = 'none';
    }

    // ── Open / close ──
    function openList() {
      wrapper.classList.add('apex-sort--open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function closeList() {
      wrapper.classList.remove('apex-sort--open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      wrapper.classList.contains('apex-sort--open') ? closeList() : openList();
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); wrapper.classList.contains('apex-sort--open') ? closeList() : openList(); }
      if (e.key === 'Escape') closeList();
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) closeList();
    });

    // ── Option selection ──
    list.addEventListener('click', function (e) {
      var item = e.target.closest('.apex-sort__option');
      if (!item) return;

      var value = item.getAttribute('data-value');
      selectEl.value = value;

      list.querySelectorAll('.apex-sort__option').forEach(function (o) {
        o.classList.remove('apex-sort__option--active');
        o.setAttribute('aria-selected', 'false');
      });
      item.classList.add('apex-sort__option--active');
      item.setAttribute('aria-selected', 'true');
      trigger.querySelector('.apex-sort__value').textContent = item.textContent;
      closeList();

      // Fire 'input' — Dawn's facet form listens for input, not change
      selectEl.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  function init() {
    document.querySelectorAll(
      '#FacetSortForm .facet-filters__sort, #FacetSortDrawerForm .facet-filters__sort'
    ).forEach(buildSortDropdown);
  }

  // ── Re-init after Dawn replaces .sorting innerHTML via AJAX ──
  function watchSorting() {
    var targets = document.querySelectorAll('.facets-vertical-sort .sorting, #FacetSortDrawerForm .sorting');
    targets.forEach(function (sortingEl) {
      new MutationObserver(function () {
        setTimeout(init, 0);
      }).observe(sortingEl, { childList: true, subtree: true });
    });
  }

  // ── Re-bold the leading number in "Showing X products" after Dawn overwrites it ──
  function boldProductCount() {
    var el = document.getElementById('ProductCountDesktop');
    if (!el) return;
    // Only reformat if it's plain text (no <strong> yet)
    if (el.querySelector('strong')) return;
    el.innerHTML = el.innerHTML.replace(/^(\s*)(\d+)/, '$1<strong>$2</strong>');
  }

  function watchProductCount() {
    var el = document.getElementById('ProductCountDesktop');
    if (!el) return;
    new MutationObserver(function () {
      setTimeout(boldProductCount, 0);
    }).observe(el, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); watchSorting(); watchProductCount(); });
  } else {
    init();
    watchSorting();
    watchProductCount();
  }
})();
